import { defineNuxtRouteMiddleware, navigateTo } from '#imports';
import { httpStatus } from '~dsc/utils/http-status';

const redirects = {
    '/biltvatt-singeltvatt/premium': '/biltvatt-singeltvatt/singeltvatt-premium',
    '/biltvatt-singeltvatt/bas': '/biltvatt-singeltvatt/singeltvatt-bas',
    '/biltvatt-singeltvatt/borstlos': '/biltvatt-singeltvatt/singeltvatt-borstlos',
    '/biltvatt-abonnemang/premium': '/biltvatt-abonnemang/privatkund/premium',
    '/biltvatt-abonnemang/borstlos': '/biltvatt-abonnemang/privatkund/borstlos',
    '/biltvatt-abonnemang/bas': '/biltvatt-abonnemang/privatkund/bas',
    '/biltvatt-abonnemang/natt': '/biltvatt-abonnemang/privatkund/natt',
    '/foretagskund-hos-dirt-carwash': '/biltvatt-abonnemang/foretagskund',
    '/abonnemang-foretag-10': '/biltvatt-abonnemang/foretagskund/foretag10',
    '/abonnemang-foretag-20': '/biltvatt-abonnemang/foretagskund/foretag20',
    '/personuppgifter-och-cookies': 'https://www.st1.se/personuppgifter-och-cookies',
    '/nu-oppnar-dirt-ny-digital-biltvatt-pa-abonnemang': '/',
};

export default defineNuxtRouteMiddleware(route => {
    const query = Object.keys(route.query).map(key => `${key}=${route.query[key]}`).join('&');

    if (Object.keys(redirects).includes(route.path)) {
        return navigateTo(
            `${redirects[route.path]}${query.length > 0 ? `?${query}` : ''}`,
            {
                external: false,
                redirectCode: httpStatus.PERMANENT_REDIRECT,
            },
        );
    }
});

